/*
 * Terms acceptance gate (ig-ryl.10).
 *
 * Every route to payment must pass an acceptance control. The cart checkbox already
 * gates #checkout; this covers the two routes that skip it — the product page's
 * "Buy it now" (dynamic checkout) and the cart's express buttons (Apple Pay, Google
 * Pay, Shop Pay), which are siblings of #checkout and were never disabled with it.
 *
 * Contract:
 *   [data-ig-terms-root]      scope container; each root has its own checkbox
 *   [data-ig-terms-agree]     the checkbox
 *   [data-ig-express-gate]    wrapper around express/dynamic buttons — click-blocked
 *                             via an overlay while unchecked (see isgyventi.css)
 *   [data-ig-terms-required]  a normal button to disable while unchecked
 *
 * The overlay is what actually blocks the click: express buttons render in iframes,
 * so a submit handler on our side never sees them.
 */
(function () {
  var LOCKED = 'ig-express-gate--locked';
  var FLASH = 'ig-terms-checkbox--flash';

  function rootOf(el) {
    return el.closest('[data-ig-terms-root]') || document;
  }

  function sync(checkbox) {
    var root = rootOf(checkbox);
    var accepted = checkbox.checked;

    root.querySelectorAll('[data-ig-express-gate]').forEach(function (gate) {
      gate.classList.toggle(LOCKED, !accepted);
    });
    root.querySelectorAll('[data-ig-terms-required]').forEach(function (button) {
      button.disabled = !accepted;
    });
  }

  function nudge(checkbox) {
    var wrapper = checkbox.closest('.ig-terms-checkbox');
    if (!wrapper) return;
    checkbox.focus();
    wrapper.classList.remove(FLASH);
    // Force a reflow so the animation restarts on a repeat click.
    void wrapper.offsetWidth;
    wrapper.classList.add(FLASH);
  }

  function init() {
    document.querySelectorAll('[data-ig-terms-agree]').forEach(function (checkbox) {
      sync(checkbox);
      checkbox.addEventListener('change', function () {
        sync(checkbox);
      });
    });

    // A click on a locked gate lands on the overlay, not the payment button.
    // Point the customer at what is blocking them.
    document.addEventListener('click', function (event) {
      var gate = event.target.closest && event.target.closest('[data-ig-express-gate]');
      if (!gate || !gate.classList.contains(LOCKED)) return;
      event.preventDefault();
      event.stopPropagation();
      var checkbox = rootOf(gate).querySelector('[data-ig-terms-agree]');
      if (checkbox) nudge(checkbox);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Variant switches and cart updates re-render these sections.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('ig:terms-gate:refresh', init);
})();
